import * as React from "react";

import { JSX } from "react/jsx-runtime";

const PhoneIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="smart-phone-01">
      <path
        id="Vector"
        d="M5.91675 9.75002C5.91675 6.1752 5.91675 4.38779 7.02731 3.27724C8.13785 2.16669 9.92527 2.16669 13.5001 2.16669C17.0749 2.16669 18.8623 2.16669 19.9729 3.27724C21.0834 4.38779 21.0834 6.1752 21.0834 9.75002V16.25C21.0834 19.8248 21.0834 21.6122 19.9729 22.7228C18.8623 23.8334 17.0749 23.8334 13.5001 23.8334C9.92527 23.8334 8.13785 23.8334 7.02731 22.7228C5.91675 21.6122 5.91675 19.8248 5.91675 16.25V9.75002Z"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
      />
      <path
        id="Vector_2"
        d="M12.4167 20.5833H14.5834"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M10.25 2.16669L10.3464 2.74521C10.5554 3.99892 10.6598 4.62578 11.0898 5.00723C11.5383 5.40514 12.1741 5.41669 13.5 5.41669C14.8259 5.41669 15.4617 5.40514 15.9102 5.00723C16.3402 4.62578 16.4446 3.99892 16.6536 2.74521L16.75 2.16669"
        stroke="black"
        strokeWidth={1.625}
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default PhoneIcon;
